const getters = {
  config: state => state.data.config,
  pressnews: state => state.data.pressnews,
  foundation: state => state.data.foundation,
  incidentAll: state => state.data.incidentAll,
  recruit: state => state.data.recruit,
  cooperation: state => state.data.cooperation
}

export default getters
